import React from "react";

import { GetStaticProps } from "next";
import {
  CTypeBeneficiaryHead,
  BTypeCardView,
  DTypeBreadCrumb,
  colors,
  FullWidthButton,
} from "goi_common";
import crematorium from "goi_common/src/constants/hwajang_detail.json";
import facilities from "goi_common/src/constants/facilities_detail.json";
import { parlorRegion } from "@/constants/parlorRegion";
import { Box, Stack } from "@mui/material";
import Head from "next/head";

const { regionColor, targetSidos } = parlorRegion;

export const getStaticProps: GetStaticProps = async () => {
  const regionCrematoriums = crematorium.filter((p) =>
    targetSidos.includes(String(p.sido))
  );
  const regionPublicFacilities = facilities.filter(
    (f) => targetSidos.includes(f.sido) && f.is_public
  );
  const description =
    "기초생활수급자 장례 혜택 안내: 1. 장례비용 지원 - 최대 80만원 2. 공설장 이용료 면제 3. 전국 화장시설 무료 이용 4. 공설 장례식장 무료 제공";

  return {
    props: {
      regionCrematoriums,
      regionPublicFacilities,
      pageDescription: description,
      pageKeywords: `기초생활수급자 장례, 기초생활수급자 장례, 장제비, 장제급여, 기초생활수급자 장례 얼마`,
      pageOgTitle: `기초생활수급자 장례 114 안내 정보 포털 ::  부산울산경남장례정보포털`,
      pageOgDescription: description,
      pageOgImage: "",
    },
  };
};

export default function index({
  regionCrematoriums,
  regionPublicFacilities,
  pageOgTitle,
}: {
  regionCrematoriums: Array<any>;
  regionPublicFacilities: Array<any>;
  pageOgTitle: string;
}) {
  const carouselItems = regionCrematoriums.map((res, i) => {
    return {
      "@type": "ListItem",
      name: `(비용안내) ${res.companyname}`,
      image: `${res.images[0].url}`,
      url: `https://www.gyeongsang-portal.co.kr/support/free-crema/${res.companyname} 소개/`,
      position: i + 1,
    };
  });

  const carouselRichSearch =
    regionCrematoriums.length > 6
      ? {
          "@context": "http://schema.org",
          "@type": "ItemList",
          itemListElement: carouselItems,
        }
      : {};
  return (
    <>
      <Head>
        <title>{pageOgTitle}</title>
        {regionCrematoriums.length > 5 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(carouselRichSearch),
            }}
          />
        )}
      </Head>

      <CTypeBeneficiaryHead
        titleSido="부산 · 울산 · 경남"
        mainColor={regionColor}
        event={{
          domain: "gyeongsang",
          path: "support",
          trigger_and_target: "goi_call",
        }}
      />

      <Stack
        margin="20px 12px"
        padding="24px 16px 10px"
        style={{
          background: "white",
          boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.12)",
        }}
        gap="12px"
      >
        <h3 className="subtitle_18_b">
          부산 울산 경남 기초생활수급자 무료 화장장
        </h3>
        {regionCrematoriums.map((res) => (
          <BTypeCardView
            descriptions={["기초생활수급자 무료"]}
            mainColor={regionColor}
            key={res.companyname}
            name={res.companyname}
            href={`/support/free-crema/${res.companyname} 소개/`}
            imgSrc={res.images[0] ? res.images[0].url : ""}
          />
        ))}
      </Stack>

      <Stack
        margin="20px 12px"
        padding="24px 16px 10px"
        style={{
          background: "white",
          boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.12)",
        }}
        gap="12px"
      >
        <h3 className="subtitle_18_b">
          부산 울산 경남 기초생활수급자 무료 장지 (공설)
        </h3>
        {regionPublicFacilities.map((res) => (
          <BTypeCardView
            // descriptions={["기초생활수급자 무료"]}
            descriptions={[""]}
            mainColor={regionColor}
            key={res.companyname}
            name={res.companyname}
            href={`/support/free-facility/${res.companyname} 소개/`}
            imgSrc={res.images[0] ? res.images[0].url : ""}
            event={{
              domain: "gyeongsang",
              path: "support",
              trigger_and_target: "uv_fr_facility_detail",
            }}
          />
        ))}
      </Stack>
    </>
  );
}
